import AuthenticationController from "./authenticationController"

export default class ApiClient {

    constructor(private auth: AuthenticationController) {}

    async getJson<T>(url: string): Promise<T|null> {
        return this.retry((auth) => this.apiCall<T>(url, {
            method: "GET",
            headers: { "Authorization": `Bearer ${auth.bearer}` }
        }));
    }

    async post<T>(url: string): Promise<T|null> {
        return this.retry((auth) => this.apiCall<T>(url, {
            method: "POST",
            headers: { "Authorization": `Bearer ${auth.bearer}` }
        }));
    }

    async postBlobAsStream<T>(url: string, blob: Blob): Promise<T|null> {
        return this.retry((auth) => this.apiCall<T>(url, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${auth.bearer}`,
                "Content-Type": blob.type || "application/octet-stream"
            },
            body: blob
        }));
    }

    private async retry<T>(getter: (a: AuthenticationController) => Promise<T|null>, allowRetry: boolean = true): Promise<T|null> {
        try {
            return await getter(this.auth);
        } catch (e) {
            if (e instanceof Error && e.message == "refresh" && allowRetry) {
                let success = await this.auth.refresh();
                if (success) {
                    return await getter(this.auth);
                } else {
                    return null;
                }
            } else {
                throw e;
            }
        }
    }

    private async apiCall<T>(url: string, requestInit: RequestInit): Promise<T|null> {
        let response: Response;
        let responseText: string;
        let json: unknown;
        const path = `${this.auth.url}cms/api/public/v1/${url}`;
        try {     
            console.info(`Calling ${path}`)
            response = await fetch(path, requestInit);
            responseText = await response.text();
        } catch (e) {
            console.error(`Error connecting`, e);
            return null;
        }
        if (!responseText) {
            console.error(`Empty response`);
            return null;
        }
        try {
            json = JSON.parse(responseText);
        } catch (e) {
            console.error(`Invalid json`, e, responseText);
            return null;
        }
        if (!(json instanceof Object)) {
            console.error(`Invalid json`, json);
            return null;
        }
        if (!response.ok) {
            if (response.status == 401) {
                throw new Error("refresh")
            } else if ("errors" in json) {
                console.error(`API call failed (${response.status})`, json.errors);
            } else if (json) {
                console.error(`API call failed (${response.status})`, json);
            } else {
                console.error(`API call failed (${response.status})`, responseText);
            }
            return null;
        }
        if ("payload" in json) {
            return json.payload as T;
        } else {
            console.error(`Missing payload`, json);
            return null;
        }
    }
}